import { VariantSelectedEvent, ThemeEvents } from '@theme/events';

/**
 * @param {VariantSelectedEvent} event
 */
function handleVariantChange(event) {
    // XXX i am a bad man

    const varId = event.target?.selectedOption.dataset.variantId;
    if (!varId) return;

    const gbbCard = event.target?.closest(`.gbb-card`);
    if (!gbbCard) return;

    const potentialImageEl = gbbCard.querySelector(`img.gbb-card-image[data-variant-id="${varId}"]`);
    if (potentialImageEl) {
        for (const anImg of gbbCard.querySelectorAll(`img.gbb-card-image`)) {
            anImg.classList.add('hidden');
        }
        potentialImageEl.classList.remove('hidden');
    }

    const potentialWineGridEl = gbbCard.querySelector(`fg-wines-grid .fg-wines-grid-item[data-variant-id="${varId}"]`);
    if (potentialWineGridEl) {
        for (const aGrid of gbbCard.querySelectorAll(`fg-wines-grid .fg-wines-grid-item`)) {
            aGrid.classList.add('hidden');
        }
        potentialWineGridEl.classList.remove('hidden');

        for (const aTab of gbbCard.querySelectorAll(`fg-wines-grid .wines-grid-tab`)) {
            aTab.classList.remove('selected');
            aTab.setAttribute('aria-selected', 'false');
            aTab.setAttribute('tabindex', '-1');
        }
        const matchingTab = gbbCard.querySelector(`fg-wines-grid .wines-grid-tab[data-show-variant-id="${varId}"]`);
        if (matchingTab) {
            matchingTab.classList.add('selected');
            matchingTab.setAttribute('aria-selected', 'true');
            matchingTab.setAttribute('tabindex', '0');
        }
    }
}

document.addEventListener(ThemeEvents.variantSelected, (e) => handleVariantChange(e));

document.addEventListener('DOMContentLoaded', () => {
    const variantTabs = document.querySelectorAll(`fg-wines-grid [data-show-variant-id]`);
    for (const aTab of variantTabs) {
        aTab.addEventListener('click', (event) => {
            const theGrid = aTab.closest('fg-wines-grid');
            const varId = event.currentTarget?.dataset?.showVariantId;
            if (!theGrid || !varId) return;

            const grids = theGrid.querySelectorAll('.fg-wines-grid-item');
            const tabs = theGrid.querySelectorAll('.tabs .wines-grid-tab');
            const activePanel = theGrid.querySelector(`.fg-wines-grid-item[data-variant-id="${varId}"]`);

            grids.forEach((g) => g.classList.add('hidden'));
            tabs.forEach((t) => {
                t.classList.remove('selected');
                t.setAttribute('aria-selected', 'false');
                t.setAttribute('tabindex', '-1');
            });
            activePanel?.classList.remove('hidden');
            aTab.classList.add('selected');
            aTab.setAttribute('aria-selected', 'true');
            aTab.setAttribute('tabindex', '0');
        });
    }
});
